import React from "react";
import { Link } from "react-router-dom";
import "./Product.css";

const Destination = (props) => {
  const { _id, name, description, price, img } = props.product || {};
  return (
    <div className="col-12 col-md-4 dest-card">
      <div className="card h-100 text-center" style={{ maxWidth: "380px" }}>
        <img src={img} className="card-img-top" alt="..." />
        <div className="card-body">
          <h5 className="card-title fw-boldr">{name}</h5>
          <p className="card-text">{description}</p>
          <p className="">${price}</p>
          <Link to={`/products/${_id}`}>
            <button className="btn btn-custom fw-bold">ORDER NOW</button>
          </Link>
        </div>
        {/* <div className="card-footer">
          <small className="text-muted fw-bold">${price}</small>
        </div> */}
      </div>
    </div>
  );
};

export default Destination;
